/**
 * Overlay dictionary — see ./index.ts. Empty entries fall back to English.
 */
export const dict: Record<string, string> = {};
